import { IResponsible } from './iresponsible';


export interface IResponsibleState {
    responsible: IResponsible,
    responsibles: Array<IResponsible>,
    error?: any
}
